/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  ApplicationStatus,
  AsoScenarioStatus,
  CalculationFlag,
  CalculationStatus,
  CustomExportRunItemStatus,
  CustomExportRunStatus,
  DataRetrievalStatus,
  ErrorResponse,
  PapSyncStatus,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Notifications<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationApplicationStatusChanged
   * @request POST:/Notifications/Application/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationApplicationStatusChanged = (
    query?: {
      applicationStatus?: ApplicationStatus;
      statusInfo?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/Application/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationTemplateStatusChanged
   * @request POST:/Notifications/Template/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationTemplateStatusChanged = (
    query?: {
      /** @format int32 */
      templateId?: number;
      templateStatus?: CalculationStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/Template/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationCalculationStatusChanged
   * @request POST:/Notifications/Calculation/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationCalculationStatusChanged = (
    query?: {
      /** @format int32 */
      calculationId?: number;
      calculationStatus?: CalculationStatus;
      papSyncStatus?: PapSyncStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/Calculation/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationTemplateFlagChanged
   * @request POST:/Notifications/Template/FlagChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationTemplateFlagChanged = (
    query?: {
      /** @format int32 */
      templateId?: number;
      templateFlag?: CalculationFlag;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/Template/FlagChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationCalculationFlagChanged
   * @request POST:/Notifications/Calculation/FlagChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationCalculationFlagChanged = (
    query?: {
      /** @format int32 */
      calculationId?: number;
      calculationFlag?: CalculationFlag;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/Calculation/FlagChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationCalculationFileStatusChanged
   * @request POST:/Notifications/CalculationFile/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationCalculationFileStatusChanged = (
    query?: {
      /** @format int32 */
      calculationId?: number;
      /** @format int32 */
      fileId?: number;
      dataRetrievalStatus?: DataRetrievalStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/CalculationFile/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationCustomExportRunStatusChanged
   * @request POST:/Notifications/CustomExportRun/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationCustomExportRunStatusChanged = (
    query?: {
      /** @format int32 */
      calculationId?: number;
      /** @format int32 */
      customExportRunId?: number;
      status?: CustomExportRunStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/CustomExportRun/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationCustomExportRunItemstatusChanged
   * @request POST:/Notifications/CustomExportRunItem/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationCustomExportRunItemstatusChanged = (
    query?: {
      /** @format int32 */
      calculationId?: number;
      /** @format int32 */
      customExportRunId?: number;
      /** @format int32 */
      customExportRunItemId?: number;
      status?: CustomExportRunItemStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/CustomExportRunItem/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Notifications
   * @name PostNotificationAsoScenarioStatusChanged
   * @request POST:/Notifications/AsoScenario/StatusChanged
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postNotificationAsoScenarioStatusChanged = (
    query?: {
      /** @format int32 */
      asoScenarioId?: number;
      status?: AsoScenarioStatus;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Notifications/AsoScenario/StatusChanged`,
      method: 'POST',
      query: query,
      ...params,
    });
}
